export const COUNTRY_CODES = [
  { code: "+251", country: "Ethiopia", iso: "et" },
  { code: "+1", country: "USA / Canada", iso: "us" },
  { code: "+44", country: "UK", iso: "gb" },
  { code: "+971", country: "UAE", iso: "ae" },
  { code: "+966", country: "Saudi Arabia", iso: "sa" },
  { code: "+254", country: "Kenya", iso: "ke" },
  { code: "+27", country: "South Africa", iso: "za" },
  { code: "+49", country: "Germany", iso: "de" },
  { code: "+90", country: "Turkey", iso: "tr" },
  { code: "+86", country: "China", iso: "cn" },
  { code: "+91", country: "India", iso: "in" },
  { code: "+33", country: "France", iso: "fr" },
  { code: "+39", country: "Italy", iso: "it" },
  { code: "+34", country: "Spain", iso: "es" },
  { code: "+81", country: "Japan", iso: "jp" },
  { code: "+82", country: "South Korea", iso: "kr" },
  { code: "+61", country: "Australia", iso: "au" },
  { code: "+55", country: "Brazil", iso: "br" },
  { code: "+52", country: "Mexico", iso: "mx" },
  { code: "+7", country: "Russia", iso: "ru" },
  { code: "+62", country: "Indonesia", iso: "id" },
  { code: "+234", country: "Nigeria", iso: "ng" },
  { code: "+20", country: "Egypt", iso: "eg" },
  { code: "+212", country: "Morocco", iso: "ma" },
  { code: "+233", country: "Ghana", iso: "gh" },
  { code: "+256", country: "Uganda", iso: "ug" },
  { code: "+255", country: "Tanzania", iso: "tz" },
  { code: "+250", country: "Rwanda", iso: "rw" },
  { code: "+253", country: "Djibouti", iso: "dj" },
  { code: "+252", country: "Somalia", iso: "so" },
  { code: "+249", country: "Sudan", iso: "sd" },
  { code: "+291", country: "Eritrea", iso: "er" },
  { code: "+974", country: "Qatar", iso: "qa" },
  { code: "+973", country: "Bahrain", iso: "bh" },
  { code: "+965", country: "Kuwait", iso: "kw" },
  { code: "+968", country: "Oman", iso: "om" },
  { code: "+962", country: "Jordan", iso: "jo" },
  { code: "+961", country: "Lebanon", iso: "lb" },
  { code: "+964", country: "Iraq", iso: "iq" },
  { code: "+98", country: "Iran", iso: "ir" },
  { code: "+92", country: "Pakistan", iso: "pk" },
  { code: "+880", country: "Bangladesh", iso: "bd" },
  { code: "+94", country: "Sri Lanka", iso: "lk" },
  { code: "+66", country: "Thailand", iso: "th" },
  { code: "+84", country: "Vietnam", iso: "vn" },
  { code: "+60", country: "Malaysia", iso: "my" },
  { code: "+63", country: "Philippines", iso: "ph" },
  { code: "+65", country: "Singapore", iso: "sg" },
  { code: "+31", country: "Netherlands", iso: "nl" },
  { code: "+46", country: "Sweden", iso: "se" },
  { code: "+47", country: "Norway", iso: "no" },
  { code: "+45", country: "Denmark", iso: "dk" },
  { code: "+358", country: "Finland", iso: "fi" },
  { code: "+48", country: "Poland", iso: "pl" },
  { code: "+41", country: "Switzerland", iso: "ch" },
  { code: "+43", country: "Austria", iso: "at" },
  { code: "+32", country: "Belgium", iso: "be" },
  { code: "+351", country: "Portugal", iso: "pt" },
  { code: "+30", country: "Greece", iso: "gr" },
  { code: "+353", country: "Ireland", iso: "ie" },
  { code: "+36", country: "Hungary", iso: "hu" },
  { code: "+420", country: "Czech Republic", iso: "cz" },
  { code: "+40", country: "Romania", iso: "ro" },
  { code: "+380", country: "Ukraine", iso: "ua" },
  { code: "+64", country: "New Zealand", iso: "nz" },
  { code: "+57", country: "Colombia", iso: "co" },
  { code: "+56", country: "Chile", iso: "cl" },
  { code: "+54", country: "Argentina", iso: "ar" },
  { code: "+51", country: "Peru", iso: "pe" },
  { code: "+58", country: "Venezuela", iso: "ve" },
];

export const DEFAULT_COUNTRY_CODE = "+251";

export const getFlagUrl = (iso: string) =>
  `https://flagcdn.com/w40/${iso}.png`;
